// 黑产安全拦截错误码
export const SAFETY_INTERCEPT_CODE = 70000

/**
 * 聚合API状态
 * 10000-请求成功
 * 20503-prepare请求失败
 * 20500-熔断开关打开
 */
export const NODE_INTERFACE_STATUS = {
  SUCCESS: 10000, // 请求成功
  PREPARE_FAIL: 20503, // 聚合后prepare请求失败
  PREPARE_EXCEPTION: 20502, // 聚合后prepare请求异常
  BREAKER_OPEN: 20500, // 熔断开关开启
  PASSPORT_EXPIRED: 30009, // passport过期
}


// 多页面双开限制错误码
export const APPLY_PAGE_LIMIT_CODE = 47000